/** Generated from docs/research/dir-report-to.json (read from official sources, verified 2026-11-03). Details marked `needsCheck` could not be fully verified; the UI tells people to confirm on the official page. */
export interface ReportToEntry {
  id: string; name: string; agency: string; category: string; whatFor: string; whoShouldReport: string | null
  urls: { label: string; url: string }[]; phone: string | null; email: string | null
  /** Deadline-clock ids (lib/breach/deadlines.ts) this destination serves. */
  clockIds: string[]; notes: string | null; needsCheck: boolean; verifiedOn: string
}
export const REPORT_TO: ReportToEntry[] = [
  {
    "id": "fbi-ic3",
    "name": "FBI Internet Crime Complaint Center (IC3)",
    "agency": "FBI",
    "category": "law-enforcement",
    "whatFor": "FBI-run hub for reporting cyber-enabled crime, filed through the online form at complaint.ic3.gov.",
    "whoShouldReport": "Anyone who has suffered a cyber-enabled crime; page says to file even if unsure the complaint qualifies.",
    "urls": [
      {
        "label": "IC3 home",
        "url": "https://www.ic3.gov/"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [],
    "notes": "IC3 says it cannot respond to every submission. The only phone printed (202-324-3691) is the FBI Press Office, so it is not listed as a reporting phone. Child exploitation goes to NCMEC and terrorism threats to tips.fbi.gov per the page.",
    "needsCheck": false,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "fbi-field-offices",
    "name": "FBI field office finder",
    "agency": "FBI",
    "category": "law-enforcement",
    "whatFor": "FBI page for locating a local field office.",
    "whoShouldReport": "Not confirmed (page blocked).",
    "urls": [
      {
        "label": "FBI field offices (not readable)",
        "url": "https://www.fbi.gov/contact-us/field-offices"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [],
    "notes": "fbi.gov returned HTTP 403 to our fetcher on /contact-us/field-offices and /investigate/cyber. URL is cited by CISA's report-ransomware page (which I read) as the FBI local contact.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "usss-cyber-field-offices",
    "name": "U.S. Secret Service cyber investigations and field offices",
    "agency": "U.S. Secret Service",
    "category": "law-enforcement",
    "whatFor": "Secret Service says to report crimes to your local field office; most field offices have a Cyber Fraud Task Force for cyber-enabled financial crime.",
    "whoShouldReport": "Not stated on the cyber page; the field-office page says to report crimes to your local field office.",
    "urls": [
      {
        "label": "Cyber investigations",
        "url": "https://www.secretservice.gov/investigations/cyber"
      },
      {
        "label": "Field offices",
        "url": "https://www.secretservice.gov/contact/field-offices"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [
      "fcc"
    ],
    "notes": "Field-office page lists a phone per U.S. office (varies by office; not copied here). No email printed. CPNI breach portal data is collected by the Secret Service and FBI per the FCC page.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "cisa-report",
    "name": "CISA incident reporting",
    "agency": "CISA (DHS)",
    "category": "regulator",
    "whatFor": "CISA's page directs incident reports to its Incident Reporting System and lists contact addresses for cyber issues and significant incidents.",
    "whoShouldReport": "Report-ransomware page: a victim reports to FBI, CISA, or the Secret Service; one report is said to notify the others. Intake form page itself did not render.",
    "urls": [
      {
        "label": "Report a cyber issue (redirects to myservices.cisa.gov/irf)",
        "url": "https://www.cisa.gov/report"
      },
      {
        "label": "Report ransomware",
        "url": "https://www.cisa.gov/stopransomware/report-ransomware"
      },
      {
        "label": "Contact us",
        "url": "https://www.cisa.gov/about/contact-us"
      }
    ],
    "phone": "1-844-Say-CISA",
    "email": "report: central@cisa.dhs.gov (significant cyber/physical incidents); Contact@mail.cisa.dhs.gov (cyber issues)",
    "clockIds": [
      "circia"
    ],
    "notes": "Contact page also lists Contact@cisa.dhs.gov for CISA Central, and 9-1-1 for emergencies. Voluntary reporting for small organizations; CIRCIA clock status is in our rule file. The IRF form at myservices.cisa.gov/irf was a JavaScript page that did not render, so form fields were not read.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ftc-reportfraud",
    "name": "FTC ReportFraud",
    "agency": "Federal Trade Commission",
    "category": "regulator",
    "whatFor": "FTC consumer fraud reporting site.",
    "whoShouldReport": "Not confirmed (page text did not render).",
    "urls": [
      {
        "label": "ReportFraud",
        "url": "https://reportfraud.ftc.gov/"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [],
    "notes": "Fetched page returned only the site name; purpose not confirmed from the page.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ftc-health-breach-form",
    "name": "FTC Health Breach Notification form",
    "agency": "Federal Trade Commission",
    "category": "regulator",
    "whatFor": "FTC's online form for reporting a breach of unsecured information in personal health records under the Health Breach Notification Rule (16 CFR Part 318).",
    "whoShouldReport": "Companies offering or maintaining personal health records that are not covered by HIPAA.",
    "urls": [
      {
        "label": "Health breach form",
        "url": "https://www.ftc.gov/business-guidance/health-breach-form"
      }
    ],
    "phone": "(202) 326-2918",
    "email": "Healthbreach@ftc.gov",
    "clockIds": [
      "ftc-hbnr"
    ],
    "notes": "Page says not to include personal information about the breach in the submission. Timing is in our rule file.",
    "needsCheck": false,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ftc-safeguards-event-form",
    "name": "FTC Safeguards Rule Security Event Reporting Form",
    "agency": "Federal Trade Commission",
    "category": "regulator",
    "whatFor": "FTC form for covered financial institutions to report security events affecting 500 or more people.",
    "whoShouldReport": "Covered financial institutions under the Safeguards Rule; third parties such as attorneys or service providers may submit on an institution's behalf.",
    "urls": [
      {
        "label": "Safeguards rule form",
        "url": "https://www.ftc.gov/business-guidance/privacy-security/gramm-leach-bliley-act/safeguards-rule-form"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [
      "ftc-safeguards"
    ],
    "notes": "No FTC phone/email printed; only a Paperwork Reduction Act mailing address. The ftc.gov/business-guidance/resources/safeguards-rule-notification-form URL is 404.",
    "needsCheck": false,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ftc-data-breach-guide-contact",
    "name": "FTC data breach guidance (individualized help)",
    "agency": "Federal Trade Commission",
    "category": "regulator",
    "whatFor": "Per IRS, the FTC offers a data breach response guide and an email for individualized guidance.",
    "whoShouldReport": "Businesses after a breach (as described by the IRS page).",
    "urls": [
      {
        "label": "IRS: who tax pros should contact",
        "url": "https://www.irs.gov/newsroom/heres-who-tax-pros-should-contact-if-their-business-suffers-a-data-theft-or-loss"
      }
    ],
    "phone": null,
    "email": "dt-brt@ftc.gov",
    "clockIds": [],
    "notes": "Email is printed on the IRS page, not on an FTC page I read.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "hhs-ocr-breach-portal",
    "name": "HHS OCR breach portal",
    "agency": "HHS Office for Civil Rights",
    "category": "regulator",
    "whatFor": "OCR portal for filing a HIPAA breach report or a 42 CFR Part 2 breach report.",
    "whoShouldReport": "Page describes HIPAA covered entities, business associates, Part 2 programs and qualified service organizations as regulated; submitter eligibility not stated.",
    "urls": [
      {
        "label": "OCR breach portal",
        "url": "https://ocrportal.hhs.gov/ocr/breach/breach_frontpage.jsf"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [
      "hipaa"
    ],
    "notes": "Page states breaches of 500+ are investigated; smaller ones depending on resources. No account or certificate requirement mentioned. If both HIPAA and Part 2 information are involved, they are reported separately.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "sec-edgar-form-8k",
    "name": "SEC EDGAR and Form 8-K Item 1.05 guidance",
    "agency": "U.S. Securities and Exchange Commission",
    "category": "regulator",
    "whatFor": "EDGAR is the SEC filing system; SEC guide describes Form 8-K Item 1.05 disclosure of material cybersecurity incidents.",
    "whoShouldReport": "Exchange Act registrants (domestic and foreign private issuers) and BDCs per the SEC guide; Form 40-F filers, asset-backed issuers and registered investment companies excluded.",
    "urls": [
      {
        "label": "EDGAR search and access",
        "url": "https://www.sec.gov/edgar/search-and-access"
      },
      {
        "label": "Small entity compliance guide",
        "url": "https://www.sec.gov/resources-small-businesses/small-business-compliance-guides/cybersecurity-risk-management-strategy-governance-incident-disclosure"
      },
      {
        "label": "SEC press release 2023-139",
        "url": "https://www.sec.gov/newsroom/press-releases/2023-139"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [
      "sec-8k",
      "sec-regsp"
    ],
    "notes": "The EDGAR page does not mention Form 8-K or filing instructions; it covers public search. Filing-agent/EDGAR Next access steps not read.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "occ-incident",
    "name": "OCC computer-security incident notification",
    "agency": "Office of the Comptroller of the Currency",
    "category": "regulator",
    "whatFor": "OCC Bulletin 2022-8 lists points of contact for bank computer-security incident notifications: BankNet help desk, BankNet submission, or the bank's supervisory office.",
    "whoShouldReport": "OCC-supervised banking organizations (per the interagency rule in our rule file).",
    "urls": [
      {
        "label": "OCC Bulletin 2022-8",
        "url": "https://www.occ.gov/news-issuances/bulletins/2022/bulletin-2022-8.html"
      }
    ],
    "phone": "(800) 641-5925",
    "email": "BankNet@occ.treas.gov",
    "clockIds": [
      "bank-36h"
    ],
    "notes": "Registered BankNet members can submit from banknet.gov; OCC recommends registering before an incident. Phone and email are the BankNet Help Desk.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "fdic-incident",
    "name": "FDIC computer-security incident notification",
    "agency": "Federal Deposit Insurance Corporation",
    "category": "regulator",
    "whatFor": "FDIC letter FIL-21-074 says notice goes to the appropriate FDIC supervisory office or an FDIC-designated point of contact by email, telephone or similar methods.",
    "whoShouldReport": "FDIC-supervised banking organizations; bank service providers notify their bank customers.",
    "urls": [
      {
        "label": "FIL-21-074",
        "url": "https://www.fdic.gov/news/financial-institution-letters/2021/fil21074.html"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [
      "bank-36h"
    ],
    "notes": "The letter prints no notification email or phone; it says FDIC would provide logistics later. Supervision@fdic.gov is printed as the Division of Risk Management Supervision contact but not stated to be for incidents, so not listed.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "frb-incident",
    "name": "Federal Reserve computer-security incident notification",
    "agency": "Board of Governors of the Federal Reserve System",
    "category": "regulator",
    "whatFor": "SR 22-4 gives the Board's contact for computer-security incident notifications.",
    "whoShouldReport": "Banking organizations whose primary federal regulator is the Board.",
    "urls": [
      {
        "label": "SR 22-4",
        "url": "https://www.federalreserve.gov/supervisionreg/srletters/SR2204.htm"
      }
    ],
    "phone": "(866) 364-0096",
    "email": "incident@frb.gov",
    "clockIds": [
      "bank-36h"
    ],
    "notes": "The email is obfuscated in the page HTML; the fetch tool decoded it from the protected-email link. A search summary reported the same address.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ncua-cyber-incident",
    "name": "NCUA cyber incident report",
    "agency": "National Credit Union Administration",
    "category": "regulator",
    "whatFor": "NCUA page lists channels for reporting a cyber incident: online form, phone voicemail, or secure email.",
    "whoShouldReport": "Federally insured credit unions with a reportable cyber incident.",
    "urls": [
      {
        "label": "NCUA cyber incident reporting",
        "url": "https://www.ncua.gov/regulation-supervision/regulatory-compliance-resources/cybersecurity-resources/cyber-incident-reporting"
      }
    ],
    "phone": "1.833.CYBERCU (1.833.292.3728)",
    "email": "cybercu@ncua.gov",
    "clockIds": [
      "ncua-72h"
    ],
    "notes": "Online report at cyberreports.ncua.gov; email goes through the NCUA Secure Email Message Center. Phone is voicemail.",
    "needsCheck": false,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "fcc-cpni-portal",
    "name": "FCC / CPNI data breach reporting facility",
    "agency": "Federal Communications Commission",
    "category": "regulator",
    "whatFor": "FCC page says carriers and interconnected VoIP providers notify the Secret Service and FBI electronically through the facility at cpnireporting.gov.",
    "whoShouldReport": "Telecommunications carriers and interconnected VoIP providers (per 47 CFR 64.2011 as described on the page).",
    "urls": [
      {
        "label": "FCC CPNI breach reporting facility",
        "url": "https://transition.fcc.gov/eb/CPNI/Report.html"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [
      "fcc"
    ],
    "notes": "This is a legacy 'transition.fcc.gov' page; it describes the Secret Service/FBI notification and does not mention the 2024 FCC-notice amendment. Printed contacts relate to OMB paperwork questions only, so omitted. fcc.gov/data-breach-reporting returned 403 and cpnireporting.gov rendered empty.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "dod-dibnet",
    "name": "DoD DIBNet cyber incident reporting",
    "agency": "DoD Cyber Crime Center (DC3)",
    "category": "regulator",
    "whatFor": "dibnet.dod.mil redirects to DC3's DIB Cybersecurity (DCISE) page.",
    "whoShouldReport": "Not confirmed from a readable page; DFARS 252.204-7012 applies to defense contractors (see our rule file).",
    "urls": [
      {
        "label": "DIBNet (redirects to DC3)",
        "url": "https://dibnet.dod.mil/"
      },
      {
        "label": "DC3 DIB Cybersecurity page (403)",
        "url": "https://www.dc3.mil/Missions/DIB-Cybersecurity/DIB-Cybersecurity-DCISE/"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [
      "dfars-72h"
    ],
    "notes": "Only the redirect was observed. A search summary suggested a DoD-approved medium assurance certificate is needed and gave a DCISE hotline and email, but that came from search results, not a page I read, so those are not used.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "irs-stakeholder-liaison",
    "name": "IRS reporting for tax professionals (Stakeholder Liaison)",
    "agency": "Internal Revenue Service",
    "category": "regulator",
    "whatFor": "IRS page lists who tax professionals should contact after data theft or loss, starting with the local Stakeholder Liaison, who notifies IRS Criminal Investigation.",
    "whoShouldReport": "Tax professionals whose business suffers a data theft or loss.",
    "urls": [
      {
        "label": "IRS: who tax pros should contact",
        "url": "https://www.irs.gov/newsroom/heres-who-tax-pros-should-contact-if-their-business-suffers-a-data-theft-or-loss"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [],
    "notes": "Page also lists police, FBI IC3, state tax agencies (via taxadmin.org), state AGs (naag.org), FTC, insurer, credit bureaus and clients. Stakeholder Liaison locator not read.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "pci-pfi-list",
    "name": "PCI SSC PCI Forensic Investigators and card breach guidance",
    "agency": "PCI Security Standards Council",
    "category": "industry",
    "whatFor": "PCI SSC qualifies PCI Forensic Investigators; its breach-response guide says to contact your acquirer and payment brands to decide whether a PFI must be engaged.",
    "whoShouldReport": "Entities with a suspected cardholder data breach; acquirers and brands set their own PFI rules.",
    "urls": [
      {
        "label": "PFI program",
        "url": "https://www.pcisecuritystandards.org/assessors_and_solutions/pci_forensic_investigators"
      },
      {
        "label": "Responding to a Cardholder Data Breach (PDF)",
        "url": "https://listings.pcisecuritystandards.org/documents/Responding_to_a_Cardholder_Data_Breach.pdf"
      },
      {
        "label": "PCI SSC about us",
        "url": "https://www.pcisecuritystandards.org/about_us/"
      }
    ],
    "phone": null,
    "email": "pfi@pcisecuritystandards.org",
    "clockIds": [],
    "notes": "Email is for PFI remediation questions. Council says compliance and validation are set by payment brands and acquirers. Guide points to FAQ 1142 for brand contacts. PFI list is a filterable search; names not captured.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "naag-find-ag",
    "name": "NAAG state attorney general directory",
    "agency": "National Association of Attorneys General",
    "category": "state",
    "whatFor": "Directory of the attorneys general of all 50 states, DC and five territories, with profile links.",
    "whoShouldReport": "Not a reporting portal; used to find the AG in each state where affected residents live.",
    "urls": [
      {
        "label": "NAAG find my AG",
        "url": "https://www.naag.org/find-my-ag/"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [],
    "notes": "State AG breach portals are a later phase. IRS page points tax pros to naag.org.",
    "needsCheck": false,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "local-law-enforcement",
    "name": "Local police report",
    "agency": "Local police",
    "category": "law-enforcement",
    "whatFor": "IRS page for tax professionals lists filing a report with local police on the breach.",
    "whoShouldReport": "Per IRS, tax professionals after data theft; general guidance not read from another agency page.",
    "urls": [
      {
        "label": "IRS: who tax pros should contact",
        "url": "https://www.irs.gov/newsroom/heres-who-tax-pros-should-contact-if-their-business-suffers-a-data-theft-or-loss"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [],
    "notes": "No official nationwide directory; use the local department.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "ofac-ransomware",
    "name": "OFAC ransomware advisory and reporting",
    "agency": "U.S. Treasury OFAC",
    "category": "regulator",
    "whatFor": "OFAC's 2021 advisory page covers sanctions risks tied to ransomware payments and links to OFAC contact and report-submission pages.",
    "whoShouldReport": "Not stated in the summary read; relevant when considering a ransom payment.",
    "urls": [
      {
        "label": "OFAC recent action 2021-09-21",
        "url": "https://ofac.treasury.gov/recent-actions/20210921"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [],
    "notes": "Advisory text itself not read.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  },
  {
    "id": "fincen-ransomware",
    "name": "FinCEN ransomware advisory FIN-2021-A004",
    "agency": "FinCEN (U.S. Treasury)",
    "category": "regulator",
    "whatFor": "FinCEN advisory on ransomware and the use of the financial system to facilitate ransom payments (issued 2021-11-08).",
    "whoShouldReport": "Not confirmed (advisory body not read); aimed at financial institutions per its title.",
    "urls": [
      {
        "label": "FIN-2021-A004",
        "url": "https://www.fincen.gov/resources/advisories/fincen-advisory-fin-2021-a004"
      }
    ],
    "phone": null,
    "email": null,
    "clockIds": [],
    "notes": "Only the landing page was read.",
    "needsCheck": true,
    "verifiedOn": "2026-11-03"
  }
]
